import config from "react-global-configuration";
import { AESEncryption, AESDecryption } from "./AesUtil";
var serviceUrl = config.get('apidomain');

export const Permission = (screenId) => {
    return new Promise((resolve, reject) => {
        // var obj = sessionStorage.getItem('TipsUser');
        // var decryptedUser = AESDecryption(obj);
        // var user = JSON.parse(decryptedUser);

        let xhr = new XMLHttpRequest();
        //xhr.open("GET", serviceUrl + '/api/Permission/CheckPermission?' + AESEncryption("userId=" + user.userId + '&screenId=' + screenId));
        xhr.open("GET", serviceUrl + '/api/Permission/CheckPermission?' + AESEncryption('screenId=' + screenId));
        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
        xhr.setRequestHeader('Authorization', 'Bearer ' + window.access_token);
        xhr.setRequestHeader('Access-Control-Allow-Methods', '*');
        xhr.onload = () => {
            if (xhr.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(JSON.parse(AESDecryption(xhr.response)));
                } else {
                    reject(xhr.statusText);
                }
            }
        };
        xhr.onerror = (err) => {
            reject(xhr.statusText);
        };
        xhr.send();

    });
};